var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTabStudies = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 23,
  viewBox: "0 0 22 23",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(0 .5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h22v22H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "M6.935 15.065H3.239a.74.74 0 0 1-.739-.739V3.24c0-.408.33-.739.74-.739h11.086c.408 0 .74.33.74.74v3.695"
}), /*#__PURE__*/React.createElement("rect", {
  width: 12.565,
  height: 12.565,
  x: 6.935,
  y: 6.935,
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  rx: 1
}))));
export { SvgTabStudies as ReactComponent };
export default __webpack_public_path__ + "assets/images/tab-studies.svg";